import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import '../scss/_sidebar.scss';


window.$ = $;

document.addEventListener('DOMContentLoaded', () => {
    $(".owl-carousel").owlCarousel({
        center: true,
        loop: true,
        items: 1,
        lazyLoad: true,
        nav:true,
        dots: false,
        navText: ['<div class="widget__company_carousel_control left"><i class="fas fa-chevron-left"></i></div>', '<div class="widget__company_carousel_control right"><i class="fas fa-chevron-right"></i></div>'],
        navContainer: ".widget__company_carousel_nav"
    });
})

